import axios from "axios";

export interface LIOrganization {
  urn: string;
  name: string;
  picture?: string;
  vanityName?: string;
}

export async function lookupLinkedInOrganization(
  q: string,
  signal?: AbortSignal
) {
  if (!q) {
    return null;
  }

  try {
    const response = await axios.request<LIOrganization>({
      method: "get",
      url: "/mentions/lookup/li-organization",
      signal,
      params: { q },
    });

    return response.data;
  } catch (error) {
    if (!axios.isCancel(error)) {
      throw error;
    }
    return null;
  }
}

export async function lookupLinkedInOrganizationOrPeople(
  q: string,
  signal?: AbortSignal,
  selectedLinkedUrn?: string
) {
  if (!q) {
    return null;
  }

  try {
    const response = await axios.request<LIOrganization[]>({
      method: "get",
      url: "/mentions/lookup/li-organization-or-people",
      signal,
      params: {
        q,
        ...(selectedLinkedUrn && { accountOrganizationUrn: selectedLinkedUrn }),
      },
    });

    return response.data;
  } catch (error) {
    if (!axios.isCancel(error)) {
      throw error;
    }
    return null;
  }
}

(window as any).lookupLinkedInOrganization = lookupLinkedInOrganization;
